import { ReloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useRequestPromise } from 'hooks/useRequest';
import { formatProductsTotal } from 'utils/formatProductsTotal';
import { getCurrencyIcon } from './getCurrencyIcon';
import { getProductsTotalStatus } from './getProductsTotalStatus';
import { ProductsTotalRequest } from './productsTotalConfig';
import {
    StyledProductsTotal,
    StyledProductsTotalIcon,
    StyledProductsTotalLabel,
    StyledProductsTotalSkeleton,
} from './styles';

type ProductsTotalValueProps = {
    declarationId: string;
    request: ProductsTotalRequest;
    currency: string | undefined;
    refreshKey: number;
};

const ProductsTotalValue = ({ declarationId, request, currency, refreshKey }: ProductsTotalValueProps) => {
    const { data, error, refetch } = useRequestPromise(() => request(declarationId), {}, [
        declarationId,
        request,
        refreshKey,
    ]);

    const status = getProductsTotalStatus(data, error);

    // refetch re-throws a failed request; the error is already kept in `error`, so it is ignored here.
    const retry = () => refetch()?.catch(() => undefined);

    if (status === 'loading') return <StyledProductsTotalSkeleton active />;

    const renderValue = () => {
        if (status === 'error') {
            return (
                <Button size="small" type="link" icon={<ReloadOutlined />} onClick={retry}>
                    Reload total
                </Button>
            );
        }

        return <strong>{formatProductsTotal(data, currency)}</strong>;
    };

    const CurrencyIcon = getCurrencyIcon(currency);

    return (
        <StyledProductsTotal>
            {CurrencyIcon && (
                <StyledProductsTotalIcon>
                    <CurrencyIcon />
                </StyledProductsTotalIcon>
            )}
            <StyledProductsTotalLabel>
                <span>Total Items Value:</span>
                {renderValue()}
            </StyledProductsTotalLabel>
        </StyledProductsTotal>
    );
};

export default ProductsTotalValue;
